import { styled } from 'styled-components';

import { spacing } from '#/theme/theme';

export const ViewListingPageSidebarSuggestionsHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 ${spacing[4]};
`;
